/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_Not_SetInputs */

const cs_office_not_set = /** @type {(inputs: Office_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const en_office_not_set = /** @type {(inputs: Office_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

/**
* | output |
* | --- |
* | "—" |
*
* @param {Office_Not_SetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_not_set = /** @type {((inputs?: Office_Not_SetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_Not_SetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_not_set(inputs)
	return cs_office_not_set(inputs)
});